module.exports = __webpack_public_path__ + "static/media/bigfield.49eaa096.jpg";